"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M10.4288 18C7.43515 18 5 15.644 5 12.749V5.542C5 5.012 5.45696 4.581 6.01946 4.581C6.58295 4.581 7.03991 5.012 7.03991 5.542V12.749C7.03991 14.615 8.52828 16.077 10.4288 16.077C12.3433 16.077 13.9601 14.553 13.9601 12.749V5.321C13.9601 4.563 13.2662 3.923 12.4438 3.923C11.6593 3.923 11.0222 4.55 11.0222 5.321V12.111C11.0222 12.643 10.5652 13.073 10.0017 13.073C9.43923 13.073 8.98226 12.643 8.98226 12.111V5.321C8.98226 3.49 10.5353 2 12.4438 2C14.4041 2 16 3.49 16 5.321V12.749C16 15.644 13.5001 18 10.4288 18Z",
    fill: "#727B7F"
  }));
};